var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: {
                    "padding-left": "10px",
                    "line-height": "46px",
                  },
                  attrs: { "separator-class": "el-icon-arrow-right" },
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "" } } }, [
                    _vm._v("当前位置"),
                  ]),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.name))]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: {
                "margin-top": "7px",
                "padding-right": "10px",
                "text-align": "right",
              },
              attrs: { span: 12 },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }